import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import * as Endpoints from "../../entities/Endpoints";

/** POST /api/MealPlan/GetReceipes */
export const fetchMealPlanRecipes = createAsyncThunk(
  "mealPlanRecipes/fetch",
  async (requestPayload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        Endpoints.FETCH_MEALPLAN_RECIPES,
        requestPayload
      );
      return data; // { Breakfast: [...], Lunch: [...], Dinner: [...], Snacks: [...] }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "Failed to fetch meal plan recipes"
      );
    }
  }
);

const initialState = {
  byMeal: { Breakfast: [], Lunch: [], Dinner: [], Snacks: [] },
  loading: false,
  error: null,
};

const normalizeByMeal = (payload = {}) => ({
  Breakfast: payload.Breakfast || payload.breakfast || [],
  Lunch: payload.Lunch || payload.lunch || [],
  Dinner: payload.Dinner || payload.dinner || [],
  Snacks: payload.Snacks || payload.snacks || [],
});

const mealPlanRecipesSlice = createSlice({
  name: "mealPlanRecipes",
  initialState,
  reducers: {
    resetMealPlanRecipes: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMealPlanRecipes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMealPlanRecipes.fulfilled, (state, action) => {
        state.loading = false;
        state.byMeal = normalizeByMeal(action.payload);
      })
      .addCase(fetchMealPlanRecipes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetMealPlanRecipes } = mealPlanRecipesSlice.actions;
export default mealPlanRecipesSlice.reducer;

/* -------- Selectors -------- */
export const selectMealPlanRecipesLoading = (state) =>
  state.mealPlanRecipes.loading;

export const selectRecipesByMeal = (meal) => (state) =>
  state.mealPlanRecipes.byMeal?.[meal] || [];

export const selectAllRecipesFlat = (state) =>
  Object.values(state.mealPlanRecipes.byMeal || {}).flat();

export const selectRecipesForImage = (state) =>
  Object.values(state.mealPlanRecipes.byMeal || {})
    .flat()
    .map((recipe) => ({
      title: recipe.title || "No Title available",
      ingredients: recipe.ingredients || [],
    }));

